import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPing from './ping.reducer';

export const getPingState = createFeatureSelector<fromPing.PingState>(
    fromPing.PING_FEATURE
);

export const selectPingFundSources = createSelector(
    getPingState,
    fromPing.selectPingFundSources
);
